import React, { Component } from 'react';
import PropTypes from 'prop-types';
import EdapModuleView from '../EdapModuleView';
import { AspectRatioCard } from '@homeaway/react-aspect-ratio-card';
import Carousel from '../Carousel';
import { LazyLoadAspectRatioCardImage, AspectRatioCardTitle } from '../Carousel/CarouselCard';

import {
  triggerEdapEvent,
  handleEdapClick
} from '../../utils/edap';

import {
  LINKPILES_CLICK_PREV,
  LINKPILES_CLICK_NEXT,
  CAROUSEL_LINKPILES_REGION_LINK_CLICK,
  MODULE_VIEW_EVENT_OPTIONS
} from './events';

import './CarouselLinkpiles.less';

const CNAME = 'CarouselLinkPiles';

class CarouselLinkpiles extends Component {
  static propTypes = {
    title: PropTypes.string,
    tiles: PropTypes.arrayOf(PropTypes.object).isRequired,
    cardAspectRatio: PropTypes.string
  }

  static defaultProps = {
    tiles: [],
    cardAspectRatio: '4x3'
  }

  constructor(props) {
    super(props);
  }

  // Arrow handlers
  handlePreviousClick() {
    triggerEdapEvent(LINKPILES_CLICK_PREV);
  }

  handleNextClick() {
    triggerEdapEvent(LINKPILES_CLICK_NEXT);
  }

  render() {
    const {
      tiles,
      title,
      cardAspectRatio
    } = this.props;

    return (
      tiles && tiles.length > 0 &&
        <section className="Content__section">
          <EdapModuleView eventOptions={MODULE_VIEW_EVENT_OPTIONS} >
            <Carousel
              title={title}
              onPreviousClick={this.handlePreviousClick}
              onNextClick={this.handleNextClick}
              cardAspectRatio={cardAspectRatio}
            >
              {tiles.map(({ title: headline, imageUrl, links }, index) => (
                <AspectRatioCard
                  key={`${index}_${headline}`}
                  aspectRatio={cardAspectRatio}
                >
                  <LazyLoadAspectRatioCardImage data-slot={'figure'} imageUri={imageUrl} aspectRatio={cardAspectRatio}/>
                  <AspectRatioCardTitle title={headline} />
                  <ul data-slot={'content'} className={`${CNAME}__list`}>
                    {links.map(({ title: text, url }, i) => (
                      <li key={`${i}_${text}`} className={`${CNAME}__item`}>
                        <a onClick={handleEdapClick(CAROUSEL_LINKPILES_REGION_LINK_CLICK)} href={url} className={`${CNAME}__link`}>{text}</a>
                      </li>
                    ))}
                  </ul>
                </AspectRatioCard>
              ))}
            </Carousel>
          </EdapModuleView>
        </section>
    );
  }
}

export default CarouselLinkpiles;